<template lang='pug'>
v-layout(class='list' row wrap)
  v-flex(xs12 sm6 md4)
    v-list(dense)
      v-list-tile
        v-list-tile-content(class='grey--text') Дата передачи объекта:
        v-list-tile-content(class='align-end font-weight-medium') &laquo;{{ step.step_info.date_startup | date }}&raquo;
      v-list-tile
        v-list-tile-content(class='grey--text') Дата выдачи ключей:
        v-list-tile-content(class='align-end font-weight-medium') &laquo;{{ step.step_info.date_keys | date }}&raquo;
  v-flex(xs12)
    rhtml(:html='step.html')
  v-flex(xs12)
    images(:images='step.images')
</template>

<script>
import Html from './Html'
import Images from './Images'

export default {
  props: ['step'],
  components: {
    Rhtml: Html,
    Images
  }
}
</script>

<style scoped>
.list >>> .v-list__tile {
  padding-right: 0;
  padding-left: 0;
}
</style>
